import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-prime-dialog',
  templateUrl: './prime-dialog.component.html',
  styleUrls: ['./prime-dialog.component.scss']
})
export class PrimeDialogComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() classes: string;
  @Input() styles: { [key: string]: string };

  @Input() header: string = '';
  @Input() pHeader: boolean = false;
  @Input() pFooter: boolean = false;

  @Input() modal: boolean = true;
  @Input() closable: boolean = true;
  @Input() draggable: boolean = false;
  @Input() resizable: boolean = false;
  @Input() closeOnScape: boolean = false;

  @Output() dialogHide = new EventEmitter<void>();

  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.dialogHide.emit();
  }
}
